export default __webpack_public_path__ + "static/media/werking-0.a81f529f.JPG";